import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuth } from './contexts/AuthContext';
import { AttachmentProvider } from './contexts/AttachmentContext';
import ModernLogin from './features/auth/components/ModernLogin';
import { AppRoutes } from './routes';
import ModernLayout from './shared/layouts/ModernLayout';
import { ErrorBoundary } from './shared/components/ErrorBoundary'
import { ScanPanelProvider } from './features/scan-panel/contexts/ScanPanelContext';
import ScanPanelMount from './features/scan-panel/components/ScanPanelMount';

const App: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // The session switches to authenticated on success: nothing else to do here
  const handleLoginSuccess = () => {};

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <ErrorBoundary>
        <ModernLogin onLoginSuccess={handleLoginSuccess} />
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <ScanPanelProvider>
        <Router>
          <AttachmentProvider>
            <ModernLayout>
              <AppRoutes />
            </ModernLayout>
            <ScanPanelMount />
          </AttachmentProvider>
        </Router>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#fff',
              color: '#363636',
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
              borderRadius: '12px',
              padding: '16px',
            },
            success: {
              iconTheme: {
                primary: '#10b981',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </ScanPanelProvider>
    </ErrorBoundary>
  );
};

export default App;